import React, { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";
import axios from "axios";
import "../Scrollbar.css";
import { get } from "../../../../../utils/api";

const FuelFilter = ({
  selectedFuelType = [],
  setSelectedFuelType,
  url,
  errors,
}) => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    // Fetch all countries from the backend
    const fetchCountries = async () => {
      try {
        const response = await get(url);
        // Extract unique country names from the user data
        const uniqueCountries = response.data.data
          ? [...new Set(response.data.data.map((user) => user.fuelType))]
          : [...new Set(response.data.data.map((user) => user.fuelType))];
        setCountries(uniqueCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const handleCountryChange = (event) => {
    const selectedEquipmentType = event.target.value;
    if (event.target.checked) {
      setSelectedFuelType([...selectedFuelType, selectedEquipmentType]);
    } else {
      setSelectedFuelType(
        selectedFuelType.filter((country) => country !== selectedEquipmentType)
      );
    }
  };

  return (
    <Box sx={{ m: "5%", mt: 0 }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: "bold",
          marginBottom: "30px",
          // m:"10%"
        }}
      >
        Fuel Type
      </Typography>
      <Box className="scrollable-container">
        {countries.length > 0 ? (
          countries.map((country, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={country}
                  checked={selectedFuelType?.includes(country)} // Ensure selectedFuelType is an array
                  onChange={handleCountryChange}
                />
              }
              label={country}
            />
          ))
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default FuelFilter;
